export type FirebaseError = { code: string; message: string }

export const transformFirebaseAuthError = (error: FirebaseError): Error => {
  let message: string
  switch (error.code) {
    case 'auth/user-not-found': {
      message = `Utilisateur inconnu`
      break
    }
    case 'auth/wrong-password': {
      message = `Mot de passe non valide`
      break
    }
    case 'auth/email-already-in-use': {
      message = `Cette adresse email est déjà utilisée`
      break
    }
    case 'auth/too-many-requests': {
      throw new Error(
        `Accès à ce compte temporairement désactivé.\nTrop de tentatives de connexion.\nRéessayez plus tard`,
      )
    }
    case 'auth/user-disabled': {
      throw new Error(
        `Ce compte a été temporairement désactivé par l'administrateur`,
      )
    }
    default:
      console.log('Error code:', error.code)
      throw error
  }
  return new Error(message)
}
